import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Globe2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Eyebrow } from "./publicUI";
import { COUNTRIES, flagUrl, IMG } from "./siteContent";

export default function Countries() {
  const nav = useNavigate();
  return (
    <div>
      <section className="relative brand-gradient-navy overflow-hidden">
        <div className="absolute inset-0 brand-dotgrid opacity-50" />
        <img src={IMG.gulf} alt="" className="absolute inset-0 w-full h-full object-cover opacity-20" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A192F] via-[#0A192F]/90 to-[#0A192F]/40" />
        <div className="relative max-w-7xl mx-auto px-6 py-20 lg:py-24">
          <div className="text-xs font-semibold uppercase tracking-[0.18em] text-sky-300 mb-3">Global Presence</div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white leading-[1.05] max-w-3xl">Countries we serve</h1>
          <p className="mt-5 text-base md:text-lg text-slate-300 max-w-2xl leading-relaxed">
            Major destinations for which we provide work visas, recruitment and immigration consulting.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6">
          {COUNTRIES.map((c, i) => (
            <motion.div key={c.name} initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.04 }}
              className="bg-white rounded-2xl border border-slate-200 p-6 hover-lift text-center" data-testid={`country-${c.iso}`}>
              <img src={flagUrl(c.iso)} alt={c.name} className="h-14 w-auto mx-auto rounded-md shadow-sm object-cover" loading="lazy" />
              <div className="font-display font-semibold text-[#0A192F] mt-4">{c.name}</div>
              <div className="inline-flex items-center gap-1 text-xs text-slate-400 mt-1"><Globe2 className="h-3.5 w-3.5" /> Work Visa &amp; Recruitment</div>
            </motion.div>
          ))}
        </div>

        <div className="mt-14 brand-gradient-navy rounded-3xl p-10 lg:p-14 relative overflow-hidden flex flex-col lg:flex-row gap-6 lg:items-center lg:justify-between">
          <div className="absolute inset-0 brand-dotgrid opacity-40" />
          <h2 className="relative font-display text-2xl lg:text-3xl font-bold text-white max-w-xl">Hiring for a destination not listed? We can help.</h2>
          <div className="relative flex gap-3">
            <Button size="lg" data-testid="countries-cta" onClick={() => nav("/contact")} className="bg-[#0088FF] hover:bg-[#0070E0] h-12">Talk to our team <ArrowRight className="h-4 w-4 ml-1" /></Button>
          </div>
        </div>
      </section>
    </div>
  );
}
